import { Spinner } from "react-bootstrap";
import { Trans } from "react-i18next";

const Loader = ({ compact, text }) => {
    function getText() {
        if (text) {
            return text + "...";
        } else {
            return <Trans>loading</Trans>;
        }
    }

    return (
        compact ? (
            <Spinner animation="grow" as="span" size="sm" />
        ) : (
            <div>
                <p className="text-center">{getText()}</p>
                <Spinner animation="grow" size="md" />
            </div >
        )
    );
};

export default Loader;
